import React from 'react'

const CareerPage = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-base-100">
      <div className="text-center p-8">
        <h3 className="text-3xl font-bold text-red-600 mb-4">Careers</h3>
        <p className="text-lg text-base-content">No data available</p>
      </div>
    </div>
  )
}

export default CareerPage